module.exports = __webpack_public_path__ + "img/manage.ad1fb3c3.svg";